import { FileKind, ParameterValue } from '@/designer/designer';
import type { NodeId } from 'web';
import type { BaseNodeData, ListSelectorData, MediaIteratorData } from '@/types/node';

/**
 * Generic utility to get iterator options for any iterator type.
 * Handles both list selectors (text iterators) and image iterators.
 *
 * @param nodeId - The iterator node's ID
 * @param iteratorData - The iterator node data (ListSelectorData or MediaIteratorData)
 * @param listSelectorOptions - Resolves list selector options via the WASM graph
 * @returns Array of options/items that the iterator will iterate over
 */
export const getIteratorValues = (
  nodeId: NodeId,
  iteratorData: ListSelectorData | MediaIteratorData,
  listSelectorOptions: (nodeId: NodeId) => string[],
): string[] | FileKind[] => {
  if (iteratorData.type === 'list_selector' || iteratorData.type === 'muxv2') {
    return listSelectorOptions(nodeId);
  }

  if (iteratorData.type === 'media_iterator') {
    const mediaData = iteratorData as MediaIteratorData;
    const filesParameter = mediaData.files;
    const parameterValue = filesParameter.data as ParameterValue;
    return parameterValue.value as FileKind[];
  }
  return [];
};

export const isIterator = (nodeData: BaseNodeData & { isIterator?: boolean }) => {
  return nodeData.isIterator || nodeData.type === 'media_iterator';
};
